import { getScansCount, getUsersCount } from "../../utils/api";

export const getTotalUsersAndScansInCompany = (company_id) => {
    return async dispatch => {
        try {
            const [user_count_response, users_scans_response] = await Promise.all([
                getUsersCount(company_id),
                getScansCount(company_id)
            ])
            dispatch({
                type: 'user_count_success',
                payload: [
                    user_count_response?.data?.data || 0,
                    users_scans_response?.data?.data?.scan_count || 0,
                    users_scans_response?.data?.data?.sub_scan_count || 0,
                ]
            })
        } catch (error) {
            dispatch({
                type: 'FETCH_ERROR',
                payload: error.message
            });
        }
    };
};

export const clearReduxForHomeComponent = () => {
    return async dispatch => {
        dispatch({
            type: 'LOGOUT',
        });
    }
}

export const clearReduxDataForHomeComponent = () => {
    return async dispatch => {
        dispatch({
            type: 'CLAER_CACHE_REDUX_HOME',
        });
    }
}

export const setCompanyId = (company_id) => ({
  type: 'SET_COMPANY_ID',
  payload: company_id,
});